import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.ts